import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TermPipe } from '@shared-lib/pipes/term.pipe';

@Component({
  selector: 'cp-term-reduction-bar-chart',
  imports: [TermPipe],
  templateUrl: './term-reduction-bar-chart.component.html',
  styleUrl: './term-reduction-bar-chart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermReductionBarChartComponent {
  @Input({ required: true }) newTerm: number;
  @Input({ required: true }) currentTerm: number;

  get newTermReductionPercentage(): number {
    const newTermReductionPercentage = 100 - (this.newTerm / this.currentTerm) * 100;
    return newTermReductionPercentage > 98 ? 98 : newTermReductionPercentage; // preventing overflowing and wrapping element to new line
  }
}
